<template>
  <div>
    <div class="divButtonRigth">
      <el-input v-model="listQuery.content" placeholder="请输入搜索内容"></el-input>
      <el-button type="primary"  size="small" @click="queryLike">查询</el-button>

      <el-button type="primary"  size="small" @click="readMsg">标记已读</el-button>

      <el-button type="primary"  size="small" @click="deleteMsg">删除</el-button>

    </div>
    <div style="margin-bottom: 20px">
      <el-checkbox v-model="checked" size="small" @change="unread(checked)">仅看未读消息</el-checkbox>

    </div>
    <bsp-table :data.sync="list" ref="msgTable"
               show-header-overflow
               show-overflow
               v-loading="loading"
               element-loading-text="拼命加载中"
               element-loading-spinner="el-icon-loading"
               :ciic-data-filter.sync="listQuery"
               @ciic-data-select="_getselect"
               @ciic-data-refresh="_getdynamicList">
      <vxe-table-column
        fixed="left"
        type="selection"
        width="60"
      />
      <bsp-table-column
        field="cusName"
        title="内容"
        align="left"
      >
        <template slot-scope="scope">
          <el-link type="primary" icon="el-icon-info" style="color: #E6A23C" v-if="scope.row.status==22"></el-link>
          <span>{{ getMsgContent(scope.row.content) }}</span>
        </template>
      </bsp-table-column>
     <!-- <bsp-table-column
        field="cusName"
        title="消息类型"
        align="left"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.type | dictFilter(msgTypes) }}</span>
        </template>
      </bsp-table-column>-->
      <bsp-table-column
        field="cusName"
        title="时间"
        align="left"
        width="150"
      >
        <template slot-scope="scope">
          <span>{{ getMsgTime(scope.row.content) }}</span>
        </template>
      </bsp-table-column>
    </bsp-table>
  </div>
</template>

<script>
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import {queryListPageByType,updateBatchMsgStatus,deletBatchMsg,queryMsgList } from  "@/api/msg/msg"
  import { mapGetters } from 'vuex';
  import store from '@/store';
  export default {
    name: "table",
    components: {bspTableColumn, bspTable},
    props: {
      currentTab: {
        type: String,
        default: ''
      },
    },
    created(){
      this._getdynamicList();

    },
    mounted() {

    },
    computed: {
      ...mapGetters([
        'dicts',
        'memberInfo'
      ]),
    },
    watch: {
      currentTab: function (newVal, oldVal) {
        //this.listQuery.tabType = newVal;
        this.listQuery.type = newVal;
        this._getdynamicList();
      }
    },
    data(){
      return{
        checked: false,
        list:[],
        selectList:[],
        selectIds:[],
        del:{ids:[12,13]},
        updateStatus:{
           ids: [],
           status: 23
        },
        listQuery:{
          limit: 20,
          memberId:'',
          page: 1,
          total: 0,
          isSort:true,// 是否加序号列
          status:0,// 消息状态
          content:'',// 消息内容
          type:0,// 消息类型
        },
        msgTypes: {
          "2":"薪酬消息",
        },
        userInfo:store.getters.userInfo
      }
    },
    filters: {

    },
    methods: {
      // 得到完成的消息，也就是消息和模板内容结合
      getMsgContent(msgContent){
        let msgCont;
        // 把消息内容转化成对象
        if(msgContent && msgContent!="null"){
          let subString = msgContent.slice(msgContent.indexOf(' ') + 1);
          msgCont= JSON.parse(subString);
          return msgCont.parms.msg;
        }else {
          return ""
        }
      },
      getMsgTime(msgContent){
        let msgCont;
        // 把消息内容转化成对象
        if(msgContent && msgContent!="null"){
          let subString = msgContent.slice(msgContent.indexOf(' ') + 1);
          msgCont= JSON.parse(subString);
          return msgCont.parms.futureTime;
        }else {
          return ""
        }
      },
      getMsgTypeName(type) {
        console.log("翻译消息类型",type);
        return this.msgTypes[type];
      },

      //获取列表数据
      _getdynamicList() {
        this.listQuery.type = this.currentTab;
        this.loading = true;
        this.listQuery.memberId=this.userInfo.cusId+this.userInfo.userId;//拼接生成查询消息的用户ID
        queryListPageByType(this.listQuery).then(res => {
          console.log("动态列表内容数据", res);
          this.showTable = true
          this.listQuery.total = res.data.total
          this.list = res.data.records;
          this.loading = false;
        }).catch(() => {
          this.loading = false
        })
      },
      /**
       * 查询未读消息
       */
      unread(value){
        console.log("查询的值 ",value);
        if(value){
          this.listQuery.status=22
          this._getdynamicList();
        }else {
          this.listQuery.status=0
          this._getdynamicList();
        }
      },
      /**
       * 模糊搜索
       */
      queryLike(){
        console.log("标记已读");
        this._getdynamicList();
      },
      /**
       * 标记已读
       */
      readMsg(){
        if(this.selectList.length<1){
          this.$message.warning('请至少选择一条数据');
          return false;
        }
        this.$confirm('确定标记成已经读？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.updateStatus.ids = this.selectIds;
          updateBatchMsgStatus(this.updateStatus).then(res=>{
            console.log("修改结果", res)
            if(res.data.data){
              this.$message.success('标记成功');
              this._getdynamicList();
            }else {
              this.$message.error('标记失败');
            }
          })
        })

      },
      /**
       * 删除消息
       */
      deleteMsg(){
        if(this.selectIds.length<1){
          this.$message.warning('请至少选择一条数据');
          return false;
        }
        this.$confirm('确定删除数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.del.ids= this.selectIds;
          deletBatchMsg(this.del).then(res => {
            console.log("删除结果", res)
            if (res.data.data) {
              this.$message.success('删除成功');
              this._getdynamicList();
            } else {
              this.$message.error('删除失败');
            }
          })
        })
      },
      /**
       *全选
       * @param checked
       * @param selection
       */
      getSelectAll({checked, row}) {
        let selects = this.$refs.msgTable.getSelectRecords();
        this.selectList = selects;
        console.log("选择",selects)
      },
      /**
       * 勾选
       * @param checked
       * @param row
       */
      _getselect(selects) {
        console.log("选择",selects);
        this.selectList = selects;
        this.selectIds =[];
        selects.forEach(item=>{
          this.selectIds.push(item.id);
          console.log("选择的id4444",item.id);
        })
        console.log("选择的id",this.selectIds);
      },


    },

  }
</script>

<style scoped>

</style>
